<template>
  <div class="team-panel">
    <header>
      <a :href="`https://www.linkedin.com/in/${linkedin}/`" target="blank" :title="`LinkedIn page of ${name}`">
        <img :src="`/assets/images/team/${linkedin}.jpg`" />
      </a>
      <h3>{{ name }}</h3>
      <h4>{{ title }}</h4>
    </header>
    <article>
      <div class="f2">{{ bio }}</div>
    </article>
  </div>
</template>

<script>
export default {
  name: "TeamPanel",
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    bio: {
      type: String,
      required: true,
    },
    linkedin: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.team-panel {
  display: inline-block;
  width: 270px;
  margin: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  color: #000;
  vertical-align: top;
  header {
    font-weight: bold;
    img {
      width: 100px;
      height: 100px;
      margin-bottom: 5px;
      border-radius: 50px;
      border: 5px $color-secondary-2 solid;
    }
  }
  h4 {
    color: $color-secondary-2;
      margin-bottom: 5px;
  }
}
</style>
